import React from 'react';
import {
  Box,
  Chip,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';

import { useGetContractActivityQuery } from '@/apis/extended/activityApi';

export const ActivityFeed = ({
  contractId,
  onDark = true,
}: {
  contractId: string;
  /** White text for the glass (dark) dashboards; false on light pages. */
  onDark?: boolean;
}) => {
  const textColor = onDark ? 'white' : 'text.primary';
  const { data, isLoading } = useGetContractActivityQuery(contractId, {
    skip: !contractId,
  });

  if (isLoading) {
    return (
      <Typography variant="body2" color="text.secondary">
        Loading activity…
      </Typography>
    );
  }

  const events = data?.data || [];
  if (events.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        No activity yet.
      </Typography>
    );
  }

  return (
    <Box>
      <Typography variant="h6" gutterBottom sx={{ color: textColor }}>
        Activity
      </Typography>
      <List dense>
        {events.map((ev) => (
          <ListItem key={ev._id} divider>
            <ListItemText
              primary={
                <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
                  <Chip size="small" label={ev.type.replace(/_/g, ' ')} />
                  <Typography variant="body2" sx={{ color: textColor }}>
                    {ev.message || ev.type}
                  </Typography>
                </Box>
              }
              secondary={
                <Typography variant="caption" color="text.secondary">
                  {ev.actorRole} • {new Date(ev.createdAt).toLocaleString()}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};
